import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { ProductCollectionRouteMap } from './Pages';

export const GPSRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={ProductCollectionRouteMap} />
    </Fragment>
)